// extracted by mini-css-extract-plugin
module.exports = {"Peers":"Peers_Peers__J7LbY","chart":"Peers_chart__RAwYi"};